import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomDialog = styled(Dialog)(() => ({
	'& .MuiDialog-paper': {
		borderRadius: '0.5rem',
		padding: '3.5rem 2.125rem',
		display: 'flex',
		maxWidth: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));
